/* @flow */

import { useCallback, useEffect, useState } from 'react';
import * as React from 'react';
import { useSelector } from 'react-redux';

import './LandmarkNavigation.css';
import Localizer from '../../helpers/localization';
import ReducedMotionManager from '../../helpers/ui/reducedMotionManager';

const LandmarkNavigation = (): React.Node => {
  const isInTheaterMode = useSelector<boolean>((state) => state.ui.isInTheaterMode);

  const [isReduced, setIsReduced] = useState<boolean>(() => ReducedMotionManager.isReduced());

  useEffect(() => {
    const unsubscribe = ReducedMotionManager.subscribe(setIsReduced);
    return unsubscribe;
  }, []);

  const handleToggleAnimationsClick = useCallback((event: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();

    ReducedMotionManager.toggle();
  }, []);

  if (isInTheaterMode) {
    // Hide skip links when player is visible
    return null;
  }

  const animationButtonText = Localizer.localize(isReduced ? 'accessibility.navigation.animations_enable' : 'accessibility.navigation.animations_disable');

  return (
    <nav aria-label={Localizer.localize('accessibility.navigation.skip_links')}>
      <button className='skipLink' id='toggle-animations' onClick={handleToggleAnimationsClick} type='button'>
        {animationButtonText}
      </button>
      <a className='skipLink' href='#main-content'>
        {Localizer.localize('accessibility.navigation.go_to_main_content')}
      </a>
      <a className='skipLink' href='#search-button'>
        {Localizer.localize('accessibility.navigation.go_to_search')}
      </a>
    </nav>
  );
};

export default LandmarkNavigation;
